<script setup lang="ts">

import LinkCard from "@/components/general/LinkCard.vue";
import Container from "@/components/general/Container.vue";

const cards = [{
	title: "Abschnitt C (Alpha)",
	subtitle: "Werkzeug zum Auszählen von Stimmen für das Verfahren zur Aufstellung von Kandidierenden " +
		"zu staatlichen Wahlen bei Volt",
	text: "Das Werkzeug unterstützt die Auszählung von Stimmen. Dabei können sowohl Stimmzettel rechtssicher " +
		"vorbereitet werden, als auch die Eingabe von Ergebnissen erfolgen. Die Ausgabe des Tools sind eine " +
		"detailierte Niederschrift und eine Darstellung des Ergebnisses. Das Tool beachtet auch Sonderfälle wie " +
		"Gleichstände.",
	link: "abschnitt-c-setup"
}, {
	title: "Stimmzettel (Beta)",
	subtitle: "Werkzeug zum Erstellen von Stimmzetteln",
	text: "Weiterentwicklung des volt.link/stimmzettel Werkzeugs. Ermöglicht das Erstellen von Stimmzetteln für alle " +
		"Arten von Abstimmungen auf Präsenzparteitagen",
	link: "stimmzettel"
}, {
	title: "Wahlantritt (In Entwicklung)",
	subtitle: "Erzeugung von Wahlantrittsunterlagen",
	disabled: true,
	link: "wahlantritt",
	text: "Erzeugung von Wahlantrittsunterlagen für die Teilnahme an Wahlen auf allen Ebenen, sofern z.B." +
		"kein Kandiderenden-Portal zur Verfügung steht."
}, {
	title: "Karten (Beta)",
	subtitle: "Erzeugung von Karten und Tabellen für Visualisierungszwecke und zur Koordination des Wahlantritts",
	link: "karten",
	text: "Hier findest du diverse Tools für Landkarten und Tabellen. Unter anderem können hier Wahlkreise von Adressen bestimmt werden."
}, {
	title: "Vorstand (In Entwicklung)",
	subtitle: "Werkzeug für die Vorstandsarbeit",
	link: "vorstand",
	disabled: true,
	text: "Werkzeuge für die Vorstandsarbeit. Z.B. das Erzeugen von Beschlüssen, Anträgen und Signaturen oder das Versenden von Einladungen zu Veranstaltungen."
}, {
	title: "City-Leads (In Entwicklung)",
	subtitle: "Werkzeug für die Arbeit der City-Leads",
	disabled: true,
	link: "city-leads",
	text: "Ermöglicht z. B. das Wählen von City-Leads"
}];

</script>

<template>
	<container title="Toolkit für Demokratie und Transparenz bei Volt">
		<div class="columns is-multiline">
			<div class="column is-half" v-for="card in cards">
				<link-card :disabled="card.disabled" :title="card.title" :to="card.link" link-text="Zum Tool">
					<h4>{{ card.subtitle }}</h4>
					<p>{{ card.text }}</p>
				</link-card>
			</div>
		</div>
	</container>
</template>
